import { render, staticRenderFns } from "./MarketingSetting.vue?vue&type=template&id=0ebd5db4&"
import script from "./MarketingSetting.vue?vue&type=script&lang=js&"
export * from "./MarketingSetting.vue?vue&type=script&lang=js&"
import style0 from "./MarketingSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports